import {pageInfo, initPage, getExportData, creditUpload, downLoadCreditTemplate, creditBankInfo} from './../api';
import { Message } from 'element-ui';
const credit = {
  namespaced: true,
  state: {
    total:0,
    pageResp:null,
    deleteResp: null,
    initPageObj: null,
    exportObj: null,
    creditUploadObj: null,
    creditTemplateObj: null,
    bankObj: null
  },
  mutations: {

    PAGE_INFO(state,data){
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    INIT_PAGE(state,data) {
      state.initPageObj = data.obj || {};
    },
    EXPORT_DATA(state,data){
      state.exportObj = data
    },
    CREDIT_DATA(state,data) {
      state.creditUploadObj = data;
    },
    CREDIT_DATA_TEMPLATE(state,data) {
      state.creditTemplateObj = data;
    },
    BANK_DATA(state,data) {
      state.bankObj = data.obj || {};
    }
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj){
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    //初始化页面事件
    async initPage({commit}, obj){
      let resp = await initPage(obj);
      commit('INIT_PAGE', resp);
    },
    //导出
    async getExportData({commit}, obj){
      let resp = await getExportData(obj);
      commit('EXPORT_DATA', resp);
    },
    //导入
    async creditUpload({commit}, obj){
      let resp = await creditUpload(obj);
      commit('CREDIT_DATA', resp);
    },
    //模板下载
    async downLoadCreditTemplate({commit}, obj){
      let resp = await downLoadCreditTemplate(obj);
      commit('CREDIT_DATA_TEMPLATE', resp);
    },
    async creditBankInfo({commit}, obj){
      let resp = await creditBankInfo(obj);
      commit('BANK_DATA', resp);
    }
  }
}
export default credit



// WEBPACK FOOTER //
// ./src/page/finance/credit/store/credit.store.js